
document.documentElement.classList.remove('no-js');

const observer = new IntersectionObserver((entries)=>{
  entries.forEach((entry)=>{ if(entry.isIntersecting) entry.target.classList.add('visible'); });
},{threshold:.12});
document.querySelectorAll('.reveal').forEach((el)=>observer.observe(el));

const header=document.querySelector('.site-header');
const syncHeader=()=>header?.classList.toggle('scrolled',window.scrollY>24);
window.addEventListener('scroll',syncHeader,{passive:true}); syncHeader();

const menu=document.querySelector('.menu-btn');
const nav=document.querySelector('.main-nav');
menu?.addEventListener('click',()=>{
  const open=nav.classList.toggle('open');
  menu.setAttribute('aria-expanded',String(open));
  menu.textContent=open?'✕':'☰';
});
nav?.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{nav.classList.remove('open');menu.textContent='☰';}));

const lightbox=document.querySelector('.lightbox');
const lightboxImg=lightbox?.querySelector('img');
const close=()=>{lightbox?.classList.remove('open');lightbox?.setAttribute('aria-hidden','true');document.body.style.overflow='';};
document.querySelectorAll('.gallery-shot').forEach(btn=>{
  btn.addEventListener('click',()=>{
    if(!lightbox || !lightboxImg) return;
    lightboxImg.src=btn.dataset.full;
    lightbox.classList.add('open');
    lightbox.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
  });
});
lightbox?.querySelector('.lightbox-close')?.addEventListener('click',close);
lightbox?.addEventListener('click',e=>{if(e.target===lightbox)close();});
document.addEventListener('keydown',e=>{if(e.key==='Escape')close();});
